<template>
	<button v-tooltip="{ content: lang.toggleSearch}" :class="{selected: isOpen}" class="btn filter-drawer-toggle-button" v-bind="config.attrs" @click="toggleFilters" v-html="caption">
		<config-style-injector
				:config="config"
				:root-selector="`.filter-drawer-toggle-button`"
		/>
	</button>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import featureMixin from "@/mixins/featureMixin";
//import FilterPanel from "@/features/filters/FilterPanel.vue";
import ConfigStyleInjector from "@/components/style-injector/ConfigStyleInjector.vue";

export default {
	name: "FilterDrawerToggleButton",
	components: {ConfigStyleInjector},
	mixins: [featureMixin],
	data() {
		return {
			featurePath: 'filterToggleButton',
			drawer: 'header'
		}
	},
	computed: {
		...mapState('drawer', ['drawerItems']),
		...mapGetters('filters', ["isFilterPanelOpen"]),
		isOpen() {
			return this.isFilterPanelOpen;
		},
		caption() {
			return this.config.label || 'Search'
		}
	},
	methods: {
		...mapActions('filters', ["setFilterPanelState"]),
		toggleFilters() {
			this.setFilterPanelState(!this.isOpen);
		}
	},
	beforeDestroy() {
		this.setFilterPanelState(false);
		//this.removeFromDrawer( {id: 'filters', drawer: this.drawer});
	}
}
</script>

<style lang="scss" scoped>

button.filter-drawer-toggle-button {
	background: var(--button-background);
	color: #545454 ;
	margin-right: auto;

	&.selected {
		background: #F2F2F2 !important;
		color:  var(--secondary-color) !important;
		filter: unset !important;
		svg 
		g {
			g {
				path {
					color: #545454;
				}
			}
		}
	}
}



</style>
